'use client';
import { maxSafeTimeout } from '../constants.js';

class TimeoutRangeError extends RangeError {
    constructor(){
        super(`Опция \`timeout\` не может быть больше ${maxSafeTimeout}.`);
        Object.setPrototypeOf(this, TimeoutRangeError.prototype);
    }
}

export { TimeoutRangeError };
//# sourceMappingURL=TimeoutRangeError.js.map
